import { useEffect } from "react";
import Home from "@/pages/Home";

/**
 * Catch-all route: shows the homepage to visitors, but injects
 * robots noindex so retired URLs (e.g. old /foundation links) are
 * dropped from search engine indexes on the next crawl.
 */
export default function NoIndexFallback() {
  useEffect(() => {
    let tag = document.head.querySelector('meta[name="robots"]');
    let created = false;
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      document.head.appendChild(tag);
      created = true;
    }
    tag.setAttribute("content", "noindex, nofollow");
    return () => {
      if (created) tag.remove();
      else tag.setAttribute("content", "index, follow");
    };
  }, []);
  return <Home />;
}
